<template>
  <ModalDefault modal_id="locationModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_710')"
                :footer="chat.new_location.address &&
                         chat.new_location.address !== '' &&
                         chat.new_location.latitude &&
                         chat.new_location.latitude !== '' &&
                         chat.new_location.longitude &&
                         chat.new_location.longitude !== ''"
                icon="bx bx-map mr-1">
    <div class="px-2 py-2 pb-2" slot="body">
      <div>
        <div class="animated--grow-in d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="row pb-2">
              <div class="col-md-12 pt-2 pb-0 px-3">
                <label class="mt-0 mb-2">{{ getTranslations('expression_175') }}</label>
                <div class="input-group mb-2">
                  <input type="text"
                         id="share_address"
                         @keydown.enter="getLonLat()"
                         :placeholder="getTranslations('expression_711')"
                         v-model="chat.new_location.address"
                         class="input_forms form-control">
                  <div class="ml-4 mt-1">
                        <span @click.prevent="getLonLat()"
                              class="shadow-sm cursor_pointer rounded-0 btn-sm btn-secondary text-white py-2 px-3">
<!--                          <i class="bx bx-save"></i>-->
                        <span class="">{{ getTranslations('expression_712') }}</span>
                      </span>
                  </div>
                </div>
              </div>
              <div class="col-md-12 pt-2 pb-0 px-3">
                <iframe width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" id="gmap_canvas"
                        :src="`https://maps.google.com/maps?width=auto&height=auto&hl=en&q=${chat.new_location.latitude},${chat.new_location.longitude}&area=01000&t=&z=18&ie=UTF8&iwloc=B&output=embed&callback=test`"
                        style="padding: 0; margin: 0 0 -8px;"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="!sending_message" @click.prevent="sendLocation"
           class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <i class="animated--grow-in bx bxs-send hover_icons"></i>
        <span class="text-white ml-2">{{ getTranslations('expression_562') }}</span>
      </div>

      <div v-else class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <v-progress-circular :width="3" :size="20" indeterminate color="primary"></v-progress-circular>
        <span class="text-white ml-2">{{ getTranslations('expression_36') }}</span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import axios from "axios";
import $ from "jquery";

export default {
  name: "ModalChatLocation",
  components: {
    ModalDefault,
  },
  data() {
    return {
      sending_message: false
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators']),
    ...mapGetters([
      'getChannelObject',
    ])
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    getLonLat() {
      axios.get('https://api.radar.io/v1/search/autocomplete', {
        params: {
          query: this.chat.new_location.address
        },
        headers: { 'Authorization': 'prj_live_pk_c40663b46af3b9d9c196bc63228b75ec53acde57' }
      }).then(response => {
        if(response.data.addresses.length > 0) {
          if(response.data.addresses[0].latitude != null) {
            this.chat.new_location.latitude = response.data.addresses[0].latitude;
            this.chat.new_location.longitude = response.data.addresses[0].longitude;
          }
        }
      }).catch(err => {
      })
    },
    sendLocation(){
      this.sending_message = true
      const format = {
        latitude: this.chat.new_location.latitude,
        longitude: this.chat.new_location.longitude,
        address: this.chat.new_location.address,
      }
      this.chat.ui.row_textarea = 1
      this.chat.new_location.channel_id = this.chat.ticket.channel_id
      this.chat.new_location.ticket_id = this.chat.ticket.id
      this.chat.new_location.text = `location|${JSON.stringify(format)}`
      this.chat.new_location.operator_id = this.isOperator(this.chat.ticket.department_id)
      this.chat.new_location.department_id = this.chat.ticket.department_id
      this.$store.dispatch('sendMessage', this.chat.new_location)
      this.isShowEmoji = false;

      setTimeout(() => {
        this.sending_message = false
        $('#locationModal').modal('hide')
        this.chat.new_location = {
          address: "",
          latitude: null,
          longitude: null,
        }
      }, 500)
    },
  }
}
</script>

<style scoped>

</style>
